export default __webpack_public_path__ + "static/PIQ-full-colour-RGB-dfaaa26a724dd6c45bc6a43b8b817e07.png";